import { Navigate, Route, Routes } from "react-router-dom";

import PanelSignup from "features/PanelSignup";
import ShareReview from "features/ShareManagement/ShareReview";

import NotFound from "components/NotFound";

import AuthContainerLogic from "App/AuthContainerLogic";
import ROLE from "enums/ROLE_NAME";
import useCurrentUser from "hooks/useCurrentUser";
import AccountSearcherRoutes from "./AccountSearcherRoutes";
import AuthenticatedRoutes from "./AuthenticatedRoutes";
import PublicRoutes from "./PublicRoutes";
import SuperAdminRoutes from "./SuperAdminRoutes";
import ViewerRoutes from "./ViewerRoutes";

function VidletRoutes() {
  const { role, id } = useCurrentUser();

  // Before session loads, `role` is null and we would fall back to AuthenticatedRoutes,
  // which omits super-admin-only paths (e.g. self-service-accounts). React Router then
  // matches the root `*` NotFound instead of waiting for auth. SuperAdminRoutes is the
  // broadest dashboard tree; AuthContainerLogic still blocks the outlet until `id` is set.
  const authenticatedRoutes =
    id == null
      ? SuperAdminRoutes
      : ROLE_BASED_ROUTES[role] || AuthenticatedRoutes;

  const homePath = role === ROLE.ACCOUNT_SEARCHER ? "/search" : "/dashboard";

  return (
    <Routes>
      <Route path="/" element={<Navigate to={homePath} />} />

      {PublicRoutes}

      <Route path="share/:token" element={<ShareReview />} />
      <Route path="panel-signup" element={<PanelSignup />} />

      <Route element={<AuthContainerLogic />}>{authenticatedRoutes}</Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const ROLE_BASED_ROUTES = {
  [ROLE.VIEWER]: ViewerRoutes,
  [ROLE.SUPER_ADMIN]: SuperAdminRoutes,
  [ROLE.SUPER_DUPER_ADMIN]: SuperAdminRoutes,
  [ROLE.ACCOUNT_SEARCHER]: AccountSearcherRoutes,
};

export default VidletRoutes;
